export const fitPercent = (p?: number | null) =>
  typeof p === "number" ? Math.round(p * 100) : null;
